export function convertCubicCentimetersToCubicMeters(value: number): number {
  return value / 1_000_000;
}
